import { divider } from '@flipster/styled-system/patterns';

export const Hr = () => {
  return <hr className={divider({ orientation: 'horizontal', color: 'border.default.level-1', my: 4 })} />;
};
